import { LinkingOptions } from '@react-navigation/native';
import { RootStackParamList } from '../types/navigation';
import { APP_SCHEME, WEB_BASE_URL } from '../config/appVariant';

export const linking: LinkingOptions<RootStackParamList> = {
  enabled: true,
  prefixes: Array.from(
    new Set(['http://localhost:19006', 'https://discovercache.com', WEB_BASE_URL, `${APP_SCHEME}://`])
  ),
  config: {
    screens: {
      // Specific routes first (with parameters)
      PublicShare: {
        path: 'share/:code',
        parse: {
          code: (code: string) => code,
        },
      },
      Landing: 'welcome',
      Main: {
        path: '',
        screens: {
          Tabs: {
            path: '',
            screens: {
              Home: '',
              Cache: {
                path: 'cache',
                screens: {
                  CacheList: '',
                  ItemDetail: 'item/:itemId',
                  EditExistingItem: 'item/:itemId/edit',
                }
              },
              Profile: 'profile',
            }
          },
          AddItem: 'add-item',
          AddAnalyzedItem: 'add-analyzed-item',
          SaveSuccess: 'save-success',
          GroupItems: 'group-items',
          MergeDuplicates: 'merge-duplicates',
          EditExistingItem: 'edit-item/:itemId',
          ItemDetail: 'item/:itemId',
          ReanalyzeItem: 'reanalyze-item/:itemId',
          ReportIssue: 'report-issue/:productId',
          AdminReports: 'admin-reports',
        }
      },
      Auth: {
        screens: {
          SignIn: 'sign-in',
          SignUp: 'sign-up',
        }
      },
    },
  },
};
